import produce from 'immer';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';
import { USERS_TYPES, UsersActions, UsersState } from './usersTypes';

const initialState: UsersState = {
  apiUsersRequestState: API_REQUEST_STATE.IDLE,
  apiUsersRequestError: null,
  apiAllUsersRequestState: API_REQUEST_STATE.IDLE,
  apiAllUsersRequestError: null,
  user: {
    id: '',
    username: '',
    roles: [],
  },
  allUsers: [],
};

export const usersReducer = produce((draft: UsersState, action: UsersActions) => {
  switch (action.type) {
    case USERS_TYPES.SET_API_ALL_USERS_REQUEST_ERROR:
      draft.apiAllUsersRequestError = action.payload.apiAllUsersRequestError;
      break;
    case USERS_TYPES.SET_API_ALL_USERS_REQUEST_STATE:
      draft.apiAllUsersRequestState = action.payload.apiAllUsersRequestState;
      break;
    case USERS_TYPES.SET_API_USERS_REQUEST_ERROR:
      draft.apiUsersRequestError = action.payload.apiUsersRequestError;
      break;
    case USERS_TYPES.SET_API_USERS_REQUEST_STATE:
      draft.apiUsersRequestState = action.payload.apiUsersRequestState;
      break;
    case USERS_TYPES.GET_ONE_SUCCESS:
      draft.user = action.payload.users;
      break;
    case USERS_TYPES.GET_ALL_SUCCESS:
      draft.allUsers = action.payload.users;
      break;
  }
}, initialState);
